export { default as theme } from 'prism-themes/themes/prism-atom-dark.css';
